const noticeError = (e: any, log: boolean = true) => {
  // eslint-disable-next-line no-console
  log && console?.error(e);
};

const addPageAction = (e: any, data: any) => {
  // eslint-disable-next-line no-console
  console.log(e, data);
};

const logger = {
  noticeError,
  addPageAction,
};

export default logger;
